import React, { useEffect } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";
import { useDispatch, useSelector } from "react-redux";
import {
  getMonthlyWorkHoursStatistics,
} from "../../../../../redux/overview/overviewState";

const MonthlyWorkHoursGraph = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.overview.monthlyWorkHoursStatistics?.data ?? []);

  useEffect(() => {
    dispatch(getMonthlyWorkHoursStatistics());
  }, [dispatch]);

  return (
    <HeaderComponent
      title="Monthly Work Hours Trend"
      description="Monthly employee work hours"
    >
      <BarChartBase
        data={data}
        xKey="month"
        yKey="hours"
      />
    </HeaderComponent>
  );
};

export default MonthlyWorkHoursGraph;